import {
  CancellationPolicyStrictness,
  FARE_CODES,
  FareCode
} from "@silversea-ssc/web-fares";
import { titleCase } from "title-case";

const CUSTOM_TITLE: Partial<Record<FareCode, string>> = {
  Plus: "All Inclusive Plus",
  Basic: "All Inclusive"
};

export const fareCodes = FARE_CODES.map((c) => ({
  title: CUSTOM_TITLE[c] ?? titleCase(c),
  value: c
}));

export const getLabelForFareCode = (code: string) =>
  fareCodes.find((c) => c.value == code)?.title || code;

export const cancellationPolicyStrictnessOptions =
  CancellationPolicyStrictness.map((s) => ({
    title: s,
    value: s
  }));
